export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '企业级安全',
      description: '符合ISO 27001标准，提供端到端加密和完整的安全审计功能'
    },
    {
      icon: 'ri-speed-line',
      title: '高性能处理',
      description: '优化的处理引擎，支持大批量文档处理，处理速度提升300%'
    },
    {
      icon: 'ri-global-line',
      title: '跨平台支持',
      description: '支持Windows、macOS、Linux等多平台，提供统一的API接口'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '专业技术支持',
      description: '7×24小时技术支持团队，提供快速响应和专业的技术咨询服务'
    },
    {
      icon: 'ri-code-s-slash-line',
      title: '灵活集成',
      description: '提供RESTful API和SDK，轻松集成到现有业务系统中'
    },
    {
      icon: 'ri-line-chart-line',
      title: '持续更新',
      description: '定期更新功能和安全补丁，确保系统始终保持最佳状态'
    }
  ];

  return (
    <section className="py-24 bg-white" aria-labelledby="features-heading">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <header className="text-center mb-16">
          <h2 id="features-heading" className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <strong>为什么选择我们</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            <span className="bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent font-semibold">Datalogics中国大陆指定合作伙伴</span><br />专业的<strong>技术实力</strong>和完善的<strong>服务体系</strong>，为您的业务保驾护航
          </p>
        </header>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <article 
              key={index}
              className="p-6 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-teal-100"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-teal-100 mb-4">
                <i className={`${feature.icon} text-2xl text-teal-600`} aria-hidden="true"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>{feature.title}</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
